module.exports = __webpack_public_path__ + "img/20.e095d20e.png";